// @ts-nocheck
/* Store Custom Code - Start */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import translate from "@insite/client-framework/Translate";

export const firstNameStyles: SearchTextFieldStyles = {};
const styles = firstNameStyles;

const OrderHistorySearchFirstName: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="firstName"
            label={translate("First Name")}
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterFirstName"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFirstName,
    definition: {
        group: "Order History",
        displayName: "First Name",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
/* Store Custom Code - End */
